import {
    Component,
    OnInit,
    OnDestroy,
    AfterViewInit,
    Inject,
    ElementRef,
    Renderer2,
    HostListener
} from '@angular/core';
import { Observable } from 'rxjs';
import { Store, select } from '@ngrx/store';
import { IStatusMessage, ResponseStatus } from '../../common/Interfaces';
import { tap } from 'rxjs/operators';
import { SetShowErrors } from './store/actions';
import { LoggingService } from '../../shared/services/logging/logging.service';
import { IShowErrors } from './IShowErrors';
import { isElementVisible } from '../util/is-element-visible';
import * as fromErrors from './store';
import { AppComponent } from '../../app.component';
import { AppTopbar } from '../../layout/components/app.topbar';

@Component({
    selector: 'ef-errors-sidenav',
    templateUrl: './errors-sidenav.component.html',
    styleUrls: ['./errors-sidenav.component.scss'],
    standalone: false
})
export class ErrorsSidenavComponent
    implements OnInit, OnDestroy, AfterViewInit
{
    constructor(
        @Inject(LoggingService) private log: LoggingService,
        public errorsStore: Store<fromErrors.State>,
        private myElement: ElementRef,
        public app: AppComponent
    ) {}

    public errors$: Observable<Array<IStatusMessage>>;
    public showError$: Observable<IShowErrors>;
    active = true;
    public itemClass(item: IStatusMessage): string {
        switch (item.StatusCode) {
            case ResponseStatus.Warning:
            case ResponseStatus.PartialSuccess:
            case ResponseStatus.LoginExpired:
                return 'alert-warning';
                break;
            case ResponseStatus.Failed:
            case ResponseStatus.ConcurrencyViolation:
                return 'alert-danger';
                break;
            default:
                return 'alert-danger';
                break;
        }
    }

    ngOnInit() {
        this.errors$ = this.errorsStore.pipe(select(fromErrors.getErrors));
        this.showError$ = this.errorsStore.pipe(
            select(fromErrors.getShowErrors),
            tap(e => {
                if (e.MsgEntityID) {
                    const ele = document.getElementById(
                        e.MsgEntityID.toString()
                    );
                    this.log.verbose({
                        TYPE: 'ErrorsSidenavComponent:showErrors$',
                        e,
                        ele
                    });
                    setTimeout(() => {
                        if (
                            ele &&
                            !isElementVisible(
                                ele,
                                this.myElement.nativeElement.parentElement
                            )
                        ) {
                            ele.scrollIntoView();
                        }
                    }, 100);
                } else {
                    this.log.warn({
                        type: 'ErrorsSidenavComponent:showErrors$ with no MsgEntityID',
                        e
                    });
                }
            })
        );
    }
    ngOnDestroy(): void {
        this.active = false;
    }
    ngAfterViewInit(): void {}

    selectError(item: IStatusMessage) {
        this.log.debug({ type: 'ErrorsSidenavComponent:SelectError', item });
        this.errorsStore.dispatch(
            new SetShowErrors({
                open: true,
                MsgProcessID: item.MsgProcessID,
                MsgEntityID: item.MsgEntityID
            })
        );
    }
}
